(() => {
  const root = document.querySelector('[data-sps-arch]');
  if (!root) return;
  const chips = root.querySelectorAll('[data-sps-arch-year]');
  const entries = root.querySelectorAll('.sps-entry[data-sps-drop]');
  chips.forEach((chip) => {
    const year = chip.getAttribute('data-sps-arch-year');
    if (year && year !== 'all') {
      const any = Array.from(entries).some((row) => row.getAttribute('data-sps-drop') === year);
      if (!any) chip.hidden = true;
    }
    chip.addEventListener('click', () => {
      const next = chip.getAttribute('data-sps-arch-year');
      chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
      entries.forEach((row) => {
        row.hidden = next !== 'all' && row.getAttribute('data-sps-drop') !== next;
      });
    });
  });
})();
